import React, { Component } from 'react'
import classnames from 'classnames'
import cuid from 'cuid'

/**
 * @description Base checkbox definition
 *      USAGE
 *          <Checkbox
 *              *** PROPS ***
 *          >
 *             Here we go
 *          </Checkbox>
 *
 *      PROPS - all props are optional
 *          className   - div wrapper class name definition
 *          onClick     - onClick handler - if is link, try send webview event first
 *          children    - JSX to render next to checkbox
 *          onChange    - onChange event handler
 *          onClick     - onClick event handler
 *          value       - value of checkbox
 *          name        - name of the checkbox
 *          require     - mark checkbox as required
 *          checked     - mark checkbox as checked
 *          disabled    - mark checkbox as disabled
 *          restProps   - all other props available as React says
 *
 */
export default class Checkbox extends Component {
    state = {
        id: this.props.id || cuid(),
    }

    render() {
        const {
            children,
            className,
            ...restProps
        } = this.props

        const { id } = this.state

        return (
            <div
                className={classnames({
                    'form-check mr-3': true,
                    [className]: className,
                })}
            >
                <input
                    type="checkbox"
                    id={id}
                    className="form-check-input"
                    {...restProps}
                />
                <label className="form-check-label" htmlFor={id}>
                    {children}
                </label>
            </div>
        )
    }
}
